export const auxAffectedPersonCode = 'XXX'

export const getAffectedPersonCode = (insuredRelationCode: string | null | undefined): string | null => {
  if (insuredRelationCode == null)
    return null
  else
    if (insuredRelationCode === 'INS' || insuredRelationCode === 'CAN')
      return insuredRelationCode
    else return auxAffectedPersonCode
}

